module.exports = function(value) {
    return markdown(value);
};
